module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, i, len, positioning, ref, reply, thread_updated;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (!!this.top) {
        positioning = "top: " + this.top + "px;";
      } else {
        positioning = "";
      }
      $o.push("<div class='comment-list-screen'></div>\n<div class='comment-list-container' style='" + ($e($c(positioning))) + "'>\n  <div class='" + (['comment-box-wrapper', ($e($c(this.comment.resolved ? 'resolved' : void 0))) + " " + ($e($c(this.anchored ? 'anchor' : void 0))) + " " + ($e($c(this.expanded ? 'expanded' : void 0))) + " " + ($e($c(this.active ? 'active' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n    <a name='" + ($e($c(this.comment.mark_id))) + "'></a>\n    <div class='opening-thread-container'>\n      <div class='flex-v-center flex-wrapper'>\n        <div class='flex-avatar flex-column'>");
      if (!!this.comment.formatted_start_time) {
        $o.push("          <div class='icon icon-video'></div>");
      } else if (!!this.comment.shape) {
        $o.push("          <div class='icon icon-infographic'></div>");
      } else {
        $o.push("          <div class='icon icon-article-blog-post'></div>");
      }
      $o.push("        </div>\n        <div class='flex-column flex-ellipsis-wrapper'>\n          <h6 class='as-label ellipsis-text'>");
      if (!!this.comment.asset_name) {
        $o.push("            " + $e($c(this.comment.asset_name)));
      } else {
        $o.push("            Body");
      }
      $o.push("          </h6>");
      if (!!this.comment.formatted_start_time) {
        $o.push("          <div class='subtext' notranslate='notranslate'>");
        $o.push("            " + $e($c(this.comment.formatted_start_time)));
        if (!!this.comment.formatted_end_time) {
          $o.push("            " + $e($c(" - " + this.comment.formatted_end_time)));
        }
        $o.push("          </div>");
      }
      $o.push("        </div>\n        <div class='actions flex-column'>");
      if (this.comment.resolved !== 1) {
        if (this.comment.can_be_resolved) {
          $o.push("          <button class='button js-resolve small state state-off'>Resolve</button>");
        }
      } else if (this.comment.resolved === 1) {
        $o.push("          <span class='label small'>Resolved</span>");
      }
      $o.push("        </div>\n      </div>\n      <div class='avatar-presenter flex-presenter'>\n        <div class='avatar-wrapper tooltip-hover'>\n          <img class='avatar' src='" + ($e($c(this.comment.authorable_avatar_url))) + "'>");
      if (this.comment.author_is_employee) {
        $o.push("          <span class='contently default label strong' notranslate='notranslate'>C</span>\n          <div class='tooltip'>\n            <div class='tooltip-inner-wrapper'>\n              <span notranslate='notranslate'>Contently</span>\n              employee\n            </div>\n          </div>");
      }
      if (this.comment.author_is_managing_editor) {
        $o.push("          <span class='default label me strong' notranslate='notranslate'>ME</span>\n          <div class='tooltip'>\n            <div class='tooltip-inner-wrapper'>\n              <span notranslate='notranslate'>Contently</span>\n              managing editor\n            </div>\n          </div>");
      }
      $o.push("        </div>\n        <div class='presenter-wrapper'>\n          <div class='flex-v-center flex-wrapper'>\n            <div class='flex-column flex-ellipsis-wrapper'>\n              <h5 class='comment-author-name ellipsis-text' notranslate='notranslate'>");
      $o.push("                " + $e($c(this.comment.authorable_name)));
      $o.push("              </h5>\n            </div>\n            <div class='actions flex-column'>");
      thread_updated = this.comment.thread_updated_at > this.comment.created_at;
      $o.push("              <div class='" + (['subtext', 'timestamp', 'tooltip-hover', 'dot-separated', "" + ($e($c(!this.comment.thread_read && !thread_updated ? 'updated' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' notranslate='notranslate'>\n              <span class='js-localized-datetime' notranslate data-behavior='localized-relative-time-ago' data-timestamp='" + ($e($c(this.comment.created_at))) + "'>");
      $o.push("              " + $c(this.comment.created_at_friendly));
      $o.push("              </span>\n              <div class='tooltip'>\n              <div class='tooltip-inner-wrapper'>\n              <span class='js-localized-datetime' notranslate data-behavior='localized-datetime' data-format-type='datetime' data-timestamp='" + ($e($c(this.comment.created_at))) + "'>");
      $o.push("              " + $c(this.comment.created_at_friendly));
      $o.push("              </span>\n              </div>\n              </div>\n              </div>");
      if (thread_updated) {
        $o.push("              <div class='" + (['subtext', 'timestamp', 'tooltip-hover', 'dot-separated', "" + ($e($c(!this.comment.thread_read ? 'updated' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n                Updated\n                <span class='js-localized-datetime' notranslate data-behavior='localized-relative-time-ago' data-timestamp='" + ($e($c(this.comment.thread_updated_at))) + "'>");
        $o.push("                " + $c(this.comment.thread_updated_at));
        $o.push("                </span>\n                <div class='tooltip'>\n                <div class='tooltip-inner-wrapper'>\n                <span class='js-localized-datetime' notranslate data-behavior='localized-datetime' data-format-type='datetime' data-timestamp='" + ($e($c(this.comment.thread_updated_at))) + "'>");
        $o.push("                " + $c(this.comment.thread_updated_at));
        $o.push("                </span>\n                </div>\n                </div>\n              </div>");
      }
      if (this.comment.resolved !== 1 && this.comment.can_be_updated) {
        $o.push("              <a class='icon icon-pencil js-comment-edit' href='javascript:;'></a>");
      }
      $o.push("            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class='js-comment-body-container'>\n      <div class='description-container markdown-styles'>");
      if (this.comment.highlighted_text) {
        $o.push("        <div class='" + (['highlighted-text-wrapper', "" + ($e($c(this.selectedTextChanged ? 'show' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n          <em class='subtext'>Original selected text:</em>\n          <div class='highlighted-text' notranslate='notranslate'>");
        $o.push("            " + $c(this.StringUtils.escapeHTML(this.comment.highlighted_text)));
        $o.push("          </div>\n        </div>");
      }
      $o.push("        <div class='js-comment-body' notranslate='notranslate'>");
      $o.push("          " + $c(this.markdown.toHTML(this.boldAllMentionedUsers(this.comment.body, this.comment.id, this.comment.updated_at)).autoLink({
        target: "_blank"
      })));
      $o.push("        </div>\n      </div>");
      if (this.comment.children.length !== 0) {
        if (!this.expanded) {
          $o.push("      <div class='comment-replies-container'>\n        <div class='heading-wrapper'>");
          if (this.comment.children.length) {
            $o.push("          <h6 class='as-label dot-separated' notranslate>");
            $o.push("                " + $c(this.inflector.notranslate_pluralize("reply", this.comment.children.length)));
            $o.push("          </h6>");
          }
          $o.push("          <span class='dot-separated subtext'>Most recent reply</span>\n        </div>");
          $o.push("        " + $c(this.replyTemplate({
            reply: _.last(this.comment.children),
            markdown: this.markdown,
            boldAllMentionedUsers: this.boldAllMentionedUsers
          })));
          $o.push("      </div>");
        }
        $o.push("      <div class='all-comment-replies-wrapper'>\n        <div class='comment-replies-container js-replies' notranslate='notranslate'>");
        ref = this.comment.children;
        for (i = 0, len = ref.length; i < len; i++) {
          reply = ref[i];
          $o.push("          " + $c(this.replyTemplate({
            reply: reply,
            markdown: this.markdown,
            boldAllMentionedUsers: this.boldAllMentionedUsers
          })));
        }
        $o.push("        </div>\n      </div>");
      }
      if (this.permittedToComment) {
        $o.push("      <div class='comment-form-container js-inline-comment-form'>\n        <form class='new-reply' action='/stories/" + ($e($c(this.comment.story_id))) + "/comments' data-validation='structured'>\n          <textarea id='comment_body' name='comment[body]' rows='1' placeholder='Reply...'></textarea>\n          <input type='hidden' name='comment[parent_id]' value='" + ($e($c(this.comment.id))) + "'>\n          <div class='actions'>\n            <a class='button js-cancel small transparent' href='javascript:;'>Cancel</a>\n            <button class='button secondary small'>Reply</button>\n          </div>\n        </form>\n      </div>");
      }
      $o.push("    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/story/templates/comments/comment.js.hamlc
// module id = 1707
// module chunks = 18